/**
 * Notifications Component
 * Displays user notifications from saved searches
 */

import React, { useState } from 'react';
import { useNotifications } from '../../agents/notificationAgent';
import './NotificationsComponent.css';

export default function NotificationsComponent({ userId }) {
  const {
    notifications,
    unreadCount,
    isLoading,
    error,
    markAsRead,
    markAllAsRead,
  } = useNotifications(userId);

  const [filter, setFilter] = useState('all'); // 'all', 'unread'

  const filteredNotifications = filter === 'unread'
    ? notifications.filter((n) => !n.read)
    : notifications;

  return (
    <div className="notifications-container">
      <div className="notifications-header">
        <div className="header-title">
          {/* Saved-search listing alerts. Titled "Notifications", the empty
              state read as a contradiction under the deal updates (QA 2026-10-16). */}
          <h3>Listing alerts</h3>
          {unreadCount > 0 && (
            <span className="unread-badge">{unreadCount}</span>
          )}
        </div>

        {unreadCount > 0 && (
          <button
            onClick={markAllAsRead}
            className="mark-all-button"
          >
            Mark all as read
          </button>
        )}
      </div>

      {error && (
        <div className="error-message">
          <p>{error}</p>
        </div>
      )}

      <div className="notifications-filters">
        <button
          onClick={() => setFilter('all')}
          className={`filter-button ${filter === 'all' ? 'active' : ''}`}
        >
          All ({notifications.length})
        </button>
        <button
          onClick={() => setFilter('unread')}
          className={`filter-button ${filter === 'unread' ? 'active' : ''}`}
        >
          Unread ({unreadCount})
        </button>
      </div>

      {isLoading ? (
        <div className="loading">Loading notifications...</div>
      ) : filteredNotifications.length > 0 ? (
        <div className="notifications-list">
          {filteredNotifications.map((notification) => (
            <div
              key={notification.id}
              className={`notification-item ${notification.read ? 'read' : 'unread'}`}
            >
              <div className="notification-icon">
                {notification.notification_type === 'new_listing' && '🏠'}
                {notification.notification_type === 'price_drop' && '💰'}
                {notification.notification_type === 'status_change' && '📋'}
              </div>

              <div className="notification-content">
                <p className="notification-message">
                  {notification.message}
                </p>
                <p className="notification-time">
                  {new Date(notification.sent_at).toLocaleString()}
                </p>
              </div>

              {!notification.read && (
                <button
                  onClick={() => markAsRead(notification.id)}
                  className="read-button"
                  title="Mark as read"
                >
                  ✓
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p className="empty-emoji">📭</p>
          <p>No {filter === 'unread' ? 'unread ' : ''}listing alerts. Save a search to get one when a matching home is listed.</p>
        </div>
      )}
    </div>
  );
}
